import moment from 'moment';

const YYYY_MM_DD = (val) => {
    return val ? moment(val, 'X').format('YYYY-MM-DD') : '--';
}

const YYYY_MM_DD_HH_MM = (val) => {
    return val ? moment(val, 'X').format('YYYY-MM-DD HH:mm') : '--';
}

const YYYY_MM_DD_HH_MM_SS = (val) => {
    return val ? moment(val, 'X').format('YYYY-MM-DD HH:mm:ss') : '--';
}
export {
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM,
    YYYY_MM_DD_HH_MM_SS
}


// WEBPACK FOOTER //
// ./website/filters/index.js